import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { data } from "./Data";
import { useNavigate } from "react-router-dom";

function Cards() {
    const navigate = useNavigate()
    const handleNavigate=(apiPoint)=>{
        navigate(`/${apiPoint}`)
    }
  return (
    <MDBox mt={8}>
      <MDBox mb={3}>
        <Grid container spacing={3}>
          {data.map((report, index) => (
            <Grid item xs={12} md={6} xl={2} key={index}>
              <Card
               onClick={() => handleNavigate(report.apiPoint)}
                sx={{
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
                }}
              >
                <MDBox p={2} mx={3} display="flex" justifyContent="center">
                  <MDBox
                    display="grid"
                    justifyContent="center"
                    alignItems="center"
                    width="4rem"
                    height="4rem"
                    shadow="md"
                    borderRadius="lg"
                    variant="gradient"
                  >
                    <Icon fontSize="large">{report.icon}</Icon>
                  </MDBox>
                </MDBox>
                <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    textTransform="capitalize"
                  >
                    {report.title}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Cards;
